import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Breadcrumb, Breadcrumbs, Flex, Text} from '../../UIKit';
import {RichIcon} from '../../UIKit/Icon/RichIcon';
import styles from './InfoBar.scss';
import * as locales from './locales';

export interface InfoBarProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
}

export function InfoBarComponent({breadcrumbs, className, i18n}: WithI18nProps & InfoBarProps) {
  return (
    <Flex
      className={classNames(styles.container, className)}
      alignItems="center"
      justifyContent="space-between"
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Flex alignItems="center" className={styles.currencyType}>
        <Text text={i18n.translate('currency')} type="small" resetMargin />
        <RichIcon icon="usFlag" size={16} className={styles.currencyIcon} />
      </Flex>
    </Flex>
  );
}

export const InfoBar = withI18n({
  id: 'InfoBar',
  fallback: locales.en,
})(InfoBarComponent);
